import styled from 'styled-components';

export const GradientDivider = styled.div`
  height: 1px;
  width: 100%;
  background: linear-gradient(
    270deg,
    rgba(229, 229, 229, 0) 0%,
    rgba(229, 229, 229, 0.15) 47.97%,
    rgba(229, 229, 229, 0) 100%
  );
`;
